import React, { useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { AuthContext } from 'contexts/AuthContext';

export const MobileReaderNavbar = ({ activeView, navItems, setActiveView }) => {
    const navigate = useNavigate();
    const { logout, state } = useContext(AuthContext);

    const handleLogout = () => {
        const readerInfo = sessionStorage.getItem('readerInfo');
        const hash = JSON.parse(readerInfo)?.hash;
        const id = JSON.parse(readerInfo)?.id;
        logout();
        setActiveView && setActiveView('alerts');

        if (id && hash) {
            navigate(`/public/reader/${id}?h=${hash}`);
            return;
        }
    };

    return (
        <div className="mobile-reader__navbar">
            {navItems.map((navItem) => (
                <div
                    key={navItem.value}
                    className={'mobile-reader__nav-item ' + (activeView === navItem.value ? 'mobile-reader__nav-item--active' : '')}
                    onClick={() => setActiveView(navItem.value)}>
                    <i className={'mobile-reader__nav-item-icon fa ' + navItem.icon} />
                    <div className="mobile-reader__nav-item-title">{navItem.name}</div>
                </div>
            ))}

            {(state.isAuthenticated || state.isReaderAuthenticated) ? (
                <div
                    className={'mobile-reader__nav-item'}
                    onClick={handleLogout}
                >
                    <i className={'mobile-reader__nav-item-icon fa fa-lock'} />
                    <div className="mobile-reader__nav-item-title">Logout</div>
                </div>
            ) : <div
                    className={'mobile-reader__nav-item ' + (activeView === 'login' ? 'mobile-reader__nav-item--active' : '')}
                    onClick={() => setActiveView('login')}
            >
                <i className={'mobile-reader__nav-item-icon fa fa-lock'} />
                <div className="mobile-reader__nav-item-title">Login</div>
            </div>}
        </div>
    );
};
